<!-- End Container fluid  -->
<footer class="footer">
  &copy; <span id="copyright">{{ today | date:'yyyy' }}</span> Inspired Concepts, Inc.
</footer>
